angular.module('impactx.combibudget').controller('CombiBudgetDecideController', [
    '$scope',
    '$mdDialog',
    'ctuId',
    'themeFactory',
    'TranslationService',
    'dataGen',
    CombiBudgetDecideController]);

function CombiBudgetDecideController($scope, $mdDialog, ctuId, themeFactory, TranslationService, dataGen)
{
    $scope.forwardLabel = TranslationService.get('forward');
    $scope.abortLabel = TranslationService.get('abort');
    $scope.theme = themeFactory.getTheme();

    dataGen.getData($scope, {ctuId: ctuId}, "/combibudget/decide");

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };

    this.answer = function ()
    {
        $mdDialog.hide($scope.data);
    };
}